import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { RequestListItemType } from '../../../types';

@Component({
  selector: 'lp-product-request-list-item',
  templateUrl: './product-request-list-item.component.html',
  styleUrls: ['./product-request-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductRequestListItemComponent {
  private readonly translateService = inject(TranslateService);

  @Input() item?: RequestListItemType;
  @Input() loading = false;
  @Output() onSelectItem = new EventEmitter<void>();

  get currentLang() {
    return this.translateService.currentLang;
  }
}
